import React from 'react';
import { Create } from 'react-admin';
import { getTransform } from '../rateSettingsTransform';
import RateSettingsForm from '../shared/rate-settings-form/RateSettingsForm';

const MarketLocationTypeRateSettingCreate = () => (
  <Create transform={getTransform(['market_id', 'location_type_id'], 'settings')}>
    <RateSettingsForm settingsField="settings" />
  </Create>
);

export default MarketLocationTypeRateSettingCreate;
